"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParcelPaymentOptionsDTOTypeEnum = void 0;
exports.ParcelPaymentOptionsDTOTypeEnum = {
    Collect: "COLLECT",
    Sender: "SENDER",
    ThirdParty: "THIRD_PARTY",
    Receiver: "RECEIVER",
};
//# sourceMappingURL=parcel-payment-options-dtotype-enum.js.map